import firebase from 'firebase';


export const approvePolicy = async () => {
    try {
        // here we approve the remote work policy
    } catch (error) {
        console.log('error approving policy: ', error);
    }
}

export const getUnreadPolicies = async () => { 
    try {
        const policies = await getAllSubmissions();
        const unverifiedPolicies = policies.map(co => {
            return {
                id: co.id,
                submissions: co.submissions.filter(sub => {
                    return (sub.verified !== true && sub.deleted !== true)
                })
            }
        })
        const companiesWithUnreadPolicies = unverifiedPolicies.filter(co => {
            return co.submissions.length
        })
        return companiesWithUnreadPolicies;
    } catch (error) {
        console.log('error getting unread policies');
    }
}

export const getAllSubmissions = async () => {
    try {
        const db = firebase.firestore();
        const submissionsTable = db.collection("policySubmissions");
        const companies = await submissionsTable.get();
        const res = companies.docs.map(async (doc) => {
            const id = doc.id;
            const subsForCompany = await db.collection("policySubmissions").doc(id).collection("submissions").get();
            const coSubmissions = await Promise.all(
                subsForCompany.docs.map(async (doc) => {
                    let data = doc.data();
                    data.id = doc.id;
                    return data;
                })
            )            
            return {
                id,
                submissions: coSubmissions
            }
        })

        return await Promise.all(res);
    } catch (error) {
        console.log('error fetching unread policies: ', error);
    }
}

export const getPolicyForCompanyName = (name) => {
    try {
        return {};
    } catch (error) {
        console.log(`error fetching policy for company: ${name}`)
    }
}